import { useProjectsPageSearchQueryStates } from '@/features/project/_hooks/search-projects/search-query-states';
import { ProjectsSearchAccordion } from '@/features/search/_components/projects/ProjectsSearchAccordion';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { FC, PropsWithChildren } from 'react';
import { ProjectsSearchAccordionInitializeStore } from '../../_stores/ProjectsSearchAccordionInitializeStore';
import { useProjectsSearchStore } from '../../_stores/projects-search-store';
import type {
  ProjectsSearchAccordionProviderType,
  ProjectsSearchSubmitType,
} from '../../_utils/projects-search';
import { ProjectSearchSkeleton } from './ProjectSearchSkeleton';

type Props = {
  initialFiscalYear?: string;
  onSubmit: (values: ProjectsSearchSubmitType) => Promise<void>;
  type: ProjectsSearchAccordionProviderType;
  forceInitialValues?: Partial<ProjectSearchFormType>;
};

export const ProjectsSearch: FC<PropsWithChildren<Props>> = ({
  children,
  onSubmit,
  initialFiscalYear,
  forceInitialValues,
  type,
}) => {
  const { searchQueryStates, isDebouncing } = useProjectsPageSearchQueryStates({
    useDebounceControl: true,
  });
  const { isLoading } = useProjectsSearchStore();
  return (
    <>
      <ProjectsSearchAccordionInitializeStore
        type={type}
        searchQueryStates={searchQueryStates}
        isDebouncing={isDebouncing}
      />
      {isLoading ? (
        <ProjectSearchSkeleton />
      ) : (
        <ProjectsSearchAccordion
          onSubmit={onSubmit}
          initialFiscalYear={initialFiscalYear}
          forceInitialValues={forceInitialValues}
        >
          {children}
        </ProjectsSearchAccordion>
      )}
    </>
  );
};
